import { Link } from "react-router-dom";
import { PropsWithChildren } from "react";
import newtab from "./newtab.png";
import newtabwhite from "./newtab_white.png";

interface NewTabLinkProps {
    to: string;
    id?: string;
}

export function NewTabLink(props: PropsWithChildren<NewTabLinkProps>) {
    return <span className="LinkWrapper">
        <Link id={props.id} to={props.to} target="_blank">{props.children}</Link>
        <img className="lightmode" src={newtab}></img>
        <img className="darkmode" src={newtabwhite}></img>
        <span className="LinkNewTabAdvisory">(link will open in new tab)</span>
    </span >;
}
